/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AccessMember = {
  /**
   * Department name as reported by the identity provider.
   */
  department?: string | undefined;
  /**
   * Role IDs this member holds through directory role mappings. They follow the member's directory groups and attributes, so updating the member's roles does not change them.
   */
  directoryRoleIds: Array<string>;
  /**
   * Email address.
   */
  email: string;
  /**
   * Names of the directory groups the member belongs to.
   */
  groups?: Array<string> | undefined;
  /**
   * User ID.
   */
  id: string;
  /**
   * When the member joined the organization.
   */
  joinedAt: Date;
  /**
   * Display name.
   */
  name: string;
  /**
   * Avatar URL.
   */
  photoUrl?: string | undefined;
  /**
   * Canonical principal URN for this member.
   */
  principalUrn: string;
  /**
   * Role IDs assigned directly to this member.
   */
  roleIds: Array<string>;
};

/** @internal */
export const AccessMember$inboundSchema: z.ZodMiniType<AccessMember, unknown> =
  z.pipe(
    z.object({
      department: z.optional(z.string()),
      directory_role_ids: z.array(z.string()),
      email: z.string(),
      groups: z.optional(z.array(z.string())),
      id: z.string(),
      joined_at: z.pipe(
        z.iso.datetime({ offset: true }),
        z.transform(v => new Date(v)),
      ),
      name: z.string(),
      photo_url: z.optional(z.string()),
      principal_urn: z.string(),
      role_ids: z.array(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        "directory_role_ids": "directoryRoleIds",
        "joined_at": "joinedAt",
        "photo_url": "photoUrl",
        "principal_urn": "principalUrn",
        "role_ids": "roleIds",
      });
    }),
  );

export function accessMemberFromJSON(
  jsonString: string,
): SafeParseResult<AccessMember, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AccessMember$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AccessMember' from JSON`,
  );
}
